import { combineReducers } from '@reduxjs/toolkit';

import actionsReducer from './actions';
import appReducer from './app';
import assetDetailsReducer from './asset-details';
import assetsReducer from './assets';
import authReducer from './auth';
import balanceReducer from './balance';
import commonInfoReducer from './common-info';
import companyInfoReducer from './company-info';
import creditDetailsReducer from './credit-details';
import documentsReducer from './documents';
import exchangeReducer from './exchange';
import operationsSignReducer from './operations-sign';
import orderDetailedReducer from './order-detailed';
import orderRealizationDetailedReducer from './order-realization-detailed';
import ordersReducer from './orders';
import signResultReducer from './sign-result';
import signupReducer from './signup';
import transactionsHistoryReducer from './transactions-history';
import loaderReducer from './loader';

export const rootReducer = combineReducers({
  auth: authReducer,
  actions: actionsReducer,
  orders: ordersReducer,
  orderDetailed: orderDetailedReducer,
  realizationPositions: orderRealizationDetailedReducer,
  balance: balanceReducer,
  operationsSign: operationsSignReducer,
  signResult: signResultReducer,
  transactionsHistory: transactionsHistoryReducer,
  companiesInfo: companyInfoReducer,
  commonInfo: commonInfoReducer,
  assets: assetsReducer,
  assetDetails: assetDetailsReducer,
  signup: signupReducer,
  app: appReducer,
  creditDetails: creditDetailsReducer,
  documents: documentsReducer,
  exchange: exchangeReducer,
  loader: loaderReducer,
});
